/**
 * @generated SignedSource<<11b9c9732f74ed5a3328d6aafe9172c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SocialLoginCard_brand$data = {
  readonly appConfig: {
    readonly androidAppIdentifier: string;
    readonly id: string;
    readonly iosAppIdentifier: string;
  };
  readonly facebookAppId: string | null;
  readonly facebookClientToken: string | null;
  readonly facebookLoginEnabled: boolean;
  readonly googleIosClientId: string | null;
  readonly googleLoginEnabled: boolean;
  readonly googleWebClientId: string | null;
  readonly hasFacebookAppSecret: boolean;
  readonly shopifyConfig: {
    readonly isNewCustomerAccountsEnabled: boolean;
    readonly multipassEnabled: boolean;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useBrandUpdateMutation_brand">;
  readonly " $fragmentType": "SocialLoginCard_brand";
};
export type SocialLoginCard_brand$key = {
  readonly " $data"?: SocialLoginCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"SocialLoginCard_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SocialLoginCard_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrandUpdateMutation_brand"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookAppId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasFacebookAppSecret",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookClientToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookLoginEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleIosClientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleWebClientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleLoginEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidAppIdentifier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandShopifyConfigType",
      "kind": "LinkedField",
      "name": "shopifyConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "multipassEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNewCustomerAccountsEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "a83e0e5e8cb892287cd8468c09768f1b";

export default node;
